import Rule from "../../../common/rule";
import FootballState from "../../../football/state/football-state";

/**
 * A fumbled snap leaves the ball loose with the player who muffed it, so the
 * rest of the play needs a player in possession to attribute against. Without
 * this, FumbleStats reads getCurrentPlayerInPossession() while it is still
 * unset at the start of the play and either throws or charges the fumble to a
 * stale player.
 *
 * Field position is deliberately untouched: the FumbledSnap fragment carries
 * no spot. A grounded snap is dead by rule, and its dead ball spot is recorded
 * one fragment later by FumbleRecovery, which sets the field position from the
 * recovery spot. Possession team is untouched for the same reason - the snap
 * itself does not change it, only a defensive recovery does.
 */
export default class FumbledSnapPossession extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.FumbledSnap &&
            !!fragment.fumbledBy
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        gameContext.setCurrentPlayerInPossession(fragment.fumbledBy);
    }
}
